<template>
  <v-container class="administration-costs-container">
    <InJourneyAccordion
      :accordionData="accordionData"
      :summarySection="summarySection"
      :padding="padding"
      @summaryClicked="summaryClicked"
    />
  </v-container>
</template>

<script>
  import InJourneyAccordion from '../common/InJourneyAccordion.vue';
  import { formatCurrency } from '../../constants/js/currency-input';

  export default {
    name: 'AdministrationCosts',
    components: {
      InJourneyAccordion,
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        estateCostCalculation: this.testator.estateCostCalculation,
      };
    },
    computed: {
      executorFeePercentage() {
        return this.estateCostCalculation.executorFeePercentage;
      },
      padding() {
        return this.$vuetify.breakpoint.mdAndDown ? 0 : 30;
      },
      accordionData() {
        let array = [
          {
            alwaysExpanded: false,
            title: `Executor fees (${this.executorFeePercentage}% + VAT)`,
            price: this.estateCostCalculation.executorFees,
            content: {
              reversed: false,
              headerAndTitles: [
                {
                  header: `Gross value of your estate: <span style="text-wrap: nowrap;">R ${formatCurrency(
                    this.estateCostCalculation.grossEstateValue
                  )}</span>`,
                  smallHeader: true,
                  price: undefined,
                  description:
                    'The fees your Executor is entitled to charge for the administration of your deceased estate. The maximum legal rate is 3.5% of the gross value of your estate plus VAT (for estates with a value over R250 000). The Executor is also entitled to 6% plus VAT on all income coming into the estate during the process of administration.',
                },
              ],
            },
          },
          {
            alwaysExpanded: false,
            title: `Conveyancing fees`,
            price: this.estateCostCalculation.conveyancingFees || 0,
            content: {
              headerAndTitles: [
                {
                  header: `Total ownership value of your properties: <span style="text-wrap: nowrap;">${formatCurrency(
                    this.estateCostCalculation.propertyOwnershipValue
                  )}</span>`,
                  smallHeader: true,
                  price: undefined,
                  description:
                    'Fees and taxes payable when a property is being transferred from one person (or their estate) to another. This does not include the outstanding amount on any mortgage that may be applicable.',
                },
              ],
            },
          },
          {
            alwaysExpanded: false,
            title: 'Professional fees',
            subtitle: 'These values are estimates and may vary',
            price:
              this.estateCostCalculation.mastersFees +
              this.estateCostCalculation.standardAdministrativeCosts +
              this.estateCostCalculation.testamentaryTrustFees,
            seeLessIndented: true,
            content: {
              indented: true,
              reversed: true,
              headerAndTitles: [
                {
                  header: `Master's fees`,
                  price: this.estateCostCalculation.mastersFees,
                  description:
                    "Fees payable to the Master's Office for administrating your estate.",
                },
                {
                  header: `Standard administrative costs`,
                  price: this.estateCostCalculation.standardAdministrativeCosts,
                  description:
                    'Fees payable to cover for costs of various administrative activities required for settling your estate. This will include costs for advertising and rates clearance.',
                },
              ],
            },
          },
        ];

        if (this.estateCostCalculation.testamentaryTrustFees > 0) {
          array[array.length - 1].content.headerAndTitles.push({
            header: `Testamentary trust fees`,
            price: this.estateCostCalculation.testamentaryTrustFees,
            description:
              'Fees payable to cover the costs associated with establishing a testamentary trust.',
          });
        }

        return array;
      },
      summarySection() {
        return {
          title: 'Your cost related to estate administration services',
          price: this.estateCostCalculation.estateAdministrationServicesCost,
          product: 'Estate',
          description: `<p>Find out how <span style="cursor: pointer;">Estate</span><span style="cursor: pointer;">Assist</span> can help you cover these costs</p>`,
        };
      },
    },
    created() {},
    methods: {
      summaryClicked() {
        this.$emit('summaryClicked');
      },
    },
  };
</script>

<style lang="scss">
  .administration-costs-container {
    width: 100%;
    padding: 0;
  }
</style>
